import React, { useContext, useEffect, useState } from "react";
import s from "./style.module.css";
import LitleScreen from "./litleScreen/LitleScreen";
import LargeScreen from "./largeScreen/LargeScreen";
import { PiStudentDuotone } from "react-icons/pi";
import { BsPersonWorkspace } from "react-icons/bs";
import { FaHandHoldingHeart } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "../../../node_modules/react-router-dom/dist/index";
import { ActivatedNameContext } from "../contexts/ActivatedNameContext";

export default function Experiences() {
  const [isLitleScreen, setIsLitleScreen] = useState(window.innerWidth < 994);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [isXSmallScreen, setXIsSmallScreen] = useState(
    window.innerWidth < 575.98
  );
  useEffect(() => {
    const handleResize = () => {
      setIsLitleScreen(window.innerWidth < 994);
      setIsSmallScreen(window.innerWidth < 768);
      setXIsSmallScreen(window.innerWidth < 575.98);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const contentPaulSab = () => {
    return (
      <div className={`${s.contentBox} align-items-start`}>
        <div className={`${s.contentDate}`}>2015 - 2017</div>
        <div className={`${s.contentTitle}`}>DUT Informatique</div>
        <div className={`${s.contentSubTitle}`}>
          IUT Paul Sabatier - Toulouse
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Université Toulouse III
        </div>
      </div>
    );
  };

  const contentN7 = () => {
    const align = isLitleScreen
      ? "align-items-start"
      : "align-items-end text-end";
    return (
      <div className={`${s.contentBox} ${align}`}>
        <div className={`${s.contentDate}`}>2017 - 2020</div>
        <div className={`${s.contentTitle}`}>
          Ingénieur informatique et réseaux
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Spécialité système logiciel
        </div>
        <div className={`${s.contentSubTitle}`}>ENSEEIHT - Toulouse</div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          École nationale supérieure d'électrotechnique, d'électronique,
          d'informatique, d'hydraulique et des télécommunications
        </div>
      </div>
    );
  };

  const contentOrange = () => {
    return (
      <div className={`${s.contentBox} align-items-start`}>
        <div className={`${s.contentDate}`}>2017 - 2020</div>
        <div className={`${s.contentTitle}`}>
          ORANGE FRANCE{" "}
          <span className={`${s.contentDescr} ${s.colorGrey}`}>
            (apprentissage)
          </span>
        </div>
        <div className={`${s.contentSubTitle}`}>
          Assistant projet, modélisation et développement
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Transposition d’un modèle technico-économique lié au déploiement de la
          fibre dans un environnement JAVA. Participation à toutes les phases du
          projet (analyse des besoins, spécifications, conception,
          développement, tests, création du site web) dans un contexte AGILE
          réunissant des acteurs issus de différents métiers. J’étais en charge
          de toute la partie technique et autonome dans sa mise en œuvre.​
        </div>
        <div className={`${s.contentDescr}`}>
          <span className={`${s.colorPink}`}>Technos : </span>JAVA, swing,
          jUnit, Apache POI, Maven, React, Bootstrap, Responsive design,
          PostgreSQL, Git, VBA, Qlik Sense, UML
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Méthodologie Agile (SCRUM)
        </div>
      </div>
    );
  };

  const contentKoncept = () => {
    const align = isLitleScreen
      ? "align-items-start"
      : "align-items-end text-end";
    return (
      <div className={`${s.contentBox} ${align}`}>
        <div className={`${s.contentDate}`}>2021 - 2025</div>
        <div className={`${s.contentTitle}`}>KONCEPT KOMET</div>
        <div className={`${s.contentSubTitle}`}>
          Ingénieur d'étude - Développeur Fullstack
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Intégration du groupe Koncept-Komet. Placement sur des projets
          d'envergure dans le secteur de l'aéronautique.
        </div>
      </div>
    );
  };

  const contentAirbus = () => {
    return (
      <div className={`${s.contentBox} align-items-start`}>
        <div className={`${s.contentDate}`}>2021 - 2023</div>
        <div className={`${s.contentTitle}`}>AIRBUS</div>
        <div className={`${s.contentSubTitle}`}>
          Ingénieur d'étude, modélisation et développement
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Développement de plugins pour un outil de modélisation de systèmes
          aéronautiques (CAMEO) au sein d’une équipe internationale. L’objectif
          étant d’opérer des transformations entre différents modèles de données
          afin de pouvoir convertir des modèles provenant d'une application à
          une autre. Mise en œuvre d’algorithmes complexes et optimisation.
        </div>
        <div className={`${s.contentDescr}`}>
          <span className={`${s.colorPink}`}>Technos : </span>JAVA, jUnit,
          Mockito, Maven, Jenkins, Sonar, Oracle Database, Git
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Méthodologie Agile (SCRUM)
        </div>
      </div>
    );
  };

  const contentAirfrance = () => {
    const align = isLitleScreen
      ? "align-items-start"
      : "align-items-end text-end";
    return (
      <div className={`${s.contentBox} ${align}`}>
        <div className={`${s.contentDate}`}>2023 - 2025</div>
        <div className={`${s.contentTitle}`}>AIR FRANCE</div>
        <div className={`${s.contentSubTitle}`}>
          Ingénieur d'étude, développeur Fullstack
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Développement d'une application web permettant de gérer des contrats
          en lien avec la fidélisation des entreprises et faire des simulations
          d'offres commerciales aux clients​. Stack technologique riche et
          moderne. J'ai participé activement à tous les versants du projet
          (backend, frontend, BDD, spécifications, analyses métier).
        </div>
        <div className={`${s.contentDescr}`}>
          <span className={`${s.colorPink}`}>Technos : </span>JAVA 17 (Spring
          Boot, Spring Batch, Spring MVC, Spring Data JPA, Spring Security,
          Hibernate, Maven, JMS, ActiveMq, MapStruct, jUnit, Mockito, H2,
          LiquiBase, Vault, Apache POI, Jackson), Angular 18 (Material, RxJs,
          Tailwind), Oracle Database, Putty, Postman, API Rest, GitHub, Bamboo,
          Sonar, Jira, Confluence
        </div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Méthodologie Agile (SCRUM)
        </div>
      </div>
    );
  };

  const contentDevhop = () => {
    return (
      <div className={`${s.contentBox} align-items-start`}>
        <div className={`${s.contentDate}`}>2025</div>
        <div className={`${s.contentTitle}`}>DevHop</div>
        <div className={`${s.contentDescr} ${s.colorGrey}`}>
          Consultant/Développeur - Freelance
          <br /> Développement web et logiciel, gestion de projet, conseils,
          intégration continue.
        </div>
        <div
          onClick={() => navigateTo("Compétences", "/competences")}
          className={`${s.contentSubTitle} ${s.toCompetences}`}
        >
          <span className={`${s.pinkColor}`}>
            <FaArrowRightLong className={`${s.arrowCompetences}`} />
          </span>{" "}
          Domaine d'expertise
        </div>
      </div>
    );
  };

  const icon = (imagePath, hasOffset, isLast) => {
    const offSet = hasOffset ? "offset-5" : "";
    const margin = isLitleScreen ? "ms-1" : "";
    return (
      <div
        className={`col-3 col-sm-4 col-md-2 ${offSet} d-flex flex-column align-items-center justify-content-start"
        `}
      >
        <img
          className={`${s.icon}`}
          src={"assets/iconsExperiences/" + imagePath}
          alt="icon entreprise/école"
        />
        {(!isLitleScreen || !isLast) && (
          <div className={`${s.line} ${margin}`}></div>
        )}
      </div>
    );
  };

  const iconForTitle = (iconTitle) => {
    return iconTitle === "student" ? (
      <PiStudentDuotone className={`${s.sectionIcon} me-1`} />
    ) : iconTitle === "worker" ? (
      <BsPersonWorkspace className={`${s.sectionIcon} me-2`} />
    ) : iconTitle === "end" ? (
      <FaHandHoldingHeart
        className={`${s.sectionIcon} ${s.sectionIconAventure} me-1`}
      />
    ) : (
      ""
    );
  };

  const { setActivatedName } = useContext(ActivatedNameContext);
  const navigate = useNavigate();
  const navigateTo = (pageName, path) => {
    setActivatedName(pageName);
    navigate(path);
    window.scrollTo(0, 0);
  };

  const getSectionBox = (name, iconTitle) => {
    return (
      <>
        {iconTitle === "end" ? (
          <div
            onClick={() => navigateTo("Contact", "/contact")}
            className={`${s.sectionTitle} ${s.sectionAventure} ${s.sectionTitleHover}`}
          >
            {iconForTitle(iconTitle)} {name}
          </div>
        ) : (
          <div className={s.sectionTitle}>
            {iconForTitle(iconTitle)} {name}
          </div>
        )}
      </>
    );
  };

  const section = (name, iconTitle) => {
    const marginBot = iconTitle === "end" ? "mb-5" : "";
    return (
      <div
        className={`col-12 d-flex flex-column justify-content-start align-items-center`}
      >
        {getSectionBox(name, iconTitle)}
        <div
          className={`d-flex flex-column align-items-center ${s.boxFull} ${marginBot}`}
        >
          {iconTitle === "end" ? (
            ""
          ) : (
            <div className={`${s.line} ${s.lineFixed}`}></div>
          )}
        </div>
      </div>
    );
  };

  const sectionLitleScreen = (name, iconTitle) => {
    const firstEnd = iconTitle === "student" ? false : true;
    const end = iconTitle === "end" ? true : false;
    const margin = isLitleScreen ? "ms-1" : "";
    const padding =
      end && isXSmallScreen ? "pt-2" : end && !isXSmallScreen ? "pt-3" : "";
    const alignItems =
      !isSmallScreen && isLitleScreen
        ? "align-items-center"
        : "align-items-start";
    return (
      <>
        <div
          className={`${
            iconTitle === "end" ? "" : padding ? padding : ""
          } col-3 col-sm-4 col-md-2 d-flex flex-column align-items-center justify-content-start`}
        >
          {!firstEnd && <div className={`${s.line} ${margin}`}></div>}
          {end && (
            <div
              className={`${s.contArrow} d-flex flex-row align-items-start justify-content-start`}
            >
              <FaArrowRightLong className={s.contactArrow} />
            </div>
          )}
        </div>
        <div
          className={`col-9 col-sm-8 d-flex flex-column ${alignItems} ${s.margingEquivLine}`}
        >
          {getSectionBox(name, iconTitle)}
        </div>
      </>
    );
  };

  return (
    <div>
      {isLitleScreen ? (
        <LitleScreen
          isSmallScreen={isSmallScreen}
          contentAirbus={contentAirbus}
          contentOrange={contentOrange}
          contentKoncept={contentKoncept}
          contentPaulSab={contentPaulSab}
          contentN7={contentN7}
          contentAirfrance={contentAirfrance}
          contentDevhop={contentDevhop}
          icon={icon}
          sectionLitleScreen={sectionLitleScreen}
        />
      ) : (
        <LargeScreen
          contentAirbus={contentAirbus}
          contentOrange={contentOrange}
          contentKoncept={contentKoncept}
          contentPaulSab={contentPaulSab}
          contentN7={contentN7}
          contentAirfrance={contentAirfrance}
          contentDevhop={contentDevhop}
          icon={icon}
          section={section}
        />
      )}
    </div>
  );
}
